export const fetchJson = async (url, opts = {}) => {
    if (!opts.headers) {
        opts.headers = {};
    }
    opts.headers["Accept"] = "application/json";
    const res = await fetch(url, opts);
    const json = await res.json();
    return json;
};
export const postJson = async (url, data, opts = {}) => {
    if (!opts.method) {
        opts.method = "POST";
    }
    if (!opts.headers) {
        opts.headers = {};
    }
    opts.headers["Content-Type"] = "application/json";
    opts.body = JSON.stringify(data);
    return fetchJson(url, opts);
};
export const uploadFile = (url, fileObj) => {
    const body = new FormData();
    body.append("file", fileObj);
    return fetchJson(url, { method: "POST", body });
};
//# sourceMappingURL=fetch.mjs.map